import CircularProgress from '@mui/material/CircularProgress'
import clsx from 'clsx'
import { useDateHandlers } from 'components/molecules/dateSelection/hooks'
import {
	DateSelection,
	DAYS,
	getInitials,
	isWeekDay,
	transformToWorkingHours,
	useHasSelected
} from 'components/molecules/dateSelection/index.js'
// components
import { AuthTemplate } from 'components/templates/authTemplate'
import { CONSTS } from 'config/objectConst.js'
import { workspaceApi } from 'features/workspace'
import { useMemo, useState } from 'react'
import { useAppSelector } from 'shared/hooks/store.ts'
import { typo } from 'shared/styles'
import { Button } from 'shared/ui/index.ts'

import { appSelectors } from '../../../../redux/reducers/app'
import { AccountInUseModal } from './Modal'
import css from './NoWorkingHours.module.scss'

const LEAD = `You can work up to ${CONSTS.WORKING_HOURS} hours a day.`

const getStarted = () => getInitials(isWeekDay)

const cn = AuthTemplate.cn

export function NoWorkingHours() {
	const [mutation, { isLoading }] = workspaceApi.useSetWorkingHoursMutation()
	const timeZone = useTimeZone()

	const [open, setOpen] = useState(false)
	const [hours, setHours] = useState(getStarted)

	const saveWorkingHours = () => {
		const { isValid, oneOrMoreSelected, workspaceHours } =
			transformToWorkingHours(hours)

		setHours({ ...hours })

		if (isValid && oneOrMoreSelected) {
			mutation(workspaceHours)
				.unwrap()
				.then(() => setOpen(true))
				.catch(console.error)
		}
	}

	const hasSelected = useHasSelected(hours)
	const { handleHoursChange, toggleDay } = useDateHandlers(setHours)

	return (
		<AuthTemplate active={5}>
			<h1 className={cn.title}>Working hours</h1>
			<p className={cn.text}>{timeZone}</p>

			<small className={clsx(css.note, typo.caption)}>{LEAD}</small>
			<div className={css.wrapper}>
				{DAYS.map(day => (
					<DateSelection
						className={css.item}
						dateSelectionHandler={toggleDay}
						dayOfWeek={day}
						handleDateChange={handleHoursChange}
						hours={hours[day]}
						key={day}
					/>
				))}

				<Button
					className={clsx(css.submit, !isLoading && css.arrow)}
					disabled={!hasSelected}
					onClick={saveWorkingHours}
					type='button'
				>
					{isLoading ? (
						<CircularProgress
							classes={{ colorPrimary: 'material-loader-black' }}
							size={20}
						/>
					) : (
						'Accept'
					)}
				</Button>
			</div>
			<AccountInUseModal open={open} setOpen={setOpen} />
		</AuthTemplate>
	)
}

function useTimeZone() {
	const profileTZ = useAppSelector(appSelectors.timezoneOffset)

	return useMemo(() => {
		if (profileTZ) {
			const asString = profileTZ.toString()

			const found = CONSTS.TIME_ZONES.find(item => item.value === asString)

			return found?.label ?? 0
		}

		return 0
	}, [profileTZ])
}
